import { Product } from "@/types/general";
import BaseSyncedFromSourcesBadge from "@reusables/BaseSyncedFromSourcesBadge";

export default function IntegrationsBadge({
    row,
    width,
    height,
}: {
    row: Product.Root | undefined;
    width?: number;
    height?: number;
}) {
    if (!row) return null;

    return (
        <BaseSyncedFromSourcesBadge
            width={width}
            height={height}
            integrations={[
                {
                    slug: "tripletex",
                    integrated: () => !!row.tripletex_id,
                },
                {
                    slug: "twenty_four_seven_office",
                    integrated: () => !!row.twenty_four_seven_office_id,
                },
                {
                    slug: "lime",
                    integrated: () => !!row.lime_id,
                },
                {
                    slug: "poweroffice",
                    integrated: () => !!row.poweroffice_id,
                },
                {
                    slug: "woocommerce",
                    integrated: () => !!row?.woo_id,
                },
                {
                    slug: "shopify",
                    integrated: () => !!row?.shopify_id,
                },
                {
                    slug: "susoft",
                    integrated: () => !!row?.susoft_id,
                },
            ]}
        />
    );
}